export class BatchTracingConf {
  constructor(
    public specId: string,
    public serialNumber: string,
    public vendor: string
  ) {}
}
